document.addEventListener('DOMContentLoaded', async () => {
  const variantDropdown = document.querySelector('[data-id="product-select"]');

  if (variantDropdown) {
    variantDropdown.addEventListener('change', async () => {
      const sku = variantDropdown.value;
      const response = await fetch(`/worker.js?sku=${sku}`);
      const data = await response.json();

      const quantityPriceBreaks = data.data.productVariants.edges[0].node.quantityPriceBreaks;

      updatePricingTable(quantityPriceBreaks);
    });
  }
});

function updatePricingTable(quantityPriceBreaks) {
  const pricingTable = document.querySelector('#pricing-table');

  if (!pricingTable) return;

  let html = '<table><thead><tr><th>Quantity</th><th>Compare At Price</th><th>Pricing</th></tr></thead><tbody>';

  quantityPriceBreaks.forEach(breakPoint => {
    html += `
      <tr>
        <td>${breakPoint.minimumQuantity}</td>
        <td>${breakPoint.compareAtPrice.amount} ${breakPoint.compareAtPrice.currencyCode}</td>
        <td>${breakPoint.price.amount} ${breakPoint.price.currencyCode}</td>
      </tr>
    `;
  });

  html += '</tbody></table>';

  pricingTable.innerHTML = html;
}
